import customFieldService from '@/services/customField'
import { fieldsNamesToBE } from '@/utils/customFields'
import { mapGetters } from 'vuex'
import {
  MODULE_POPUP,
  SET_SUBMIT_FORM_ERROR_POPUP_SHOW,
  SET_SUBMIT_FORM_ERROR_POPUP_TITLE,
  SET_SUBMIT_FORM_ERROR_POPUP_MESSAGE
} from '@/store/constant/mutation-types'

export const saveNewItemMixin = {
  data: function() {
    return {
      nameRules: [(v) => !!v.length || 'Please enter name'],
      saveErrors: false
    }
  },
  computed: {
    haveErrors() {
      return this.validate()
    },
    ...mapGetters('warehouses', ['getActiveWarehouse'])
  },
  methods: {
    validate() {
      return !this.preloadedItem.name.length
    },
    async save() {
      if (this.haveErrors) {
        return
      }

      const payload = {
        id: this.editId,
        inventoryId: this.getActiveWarehouse.id,
        name: this.preloadedItem.name,
        placeholder: this.preloadedItem.placeholder,
        fieldType: fieldsNamesToBE.get(this.itemType).name,
        type: fieldsNamesToBE.get(this.itemType).type,
        applyTo: this.applicableToAll ? 'ALL_ITEMS' : 'ITEMS',
        defaultValue: String(this.preloadedItem.defaultValue),
        customFieldArrayValues: this.preloadedItem.customFieldArrayValues
      }

      const doRequest = async (isEdit, payload) => {
        if (isEdit) {
          return await customFieldService.changeCustomField(payload)
        } else {
          return await customFieldService.addCustomField(payload)
        }
      }

      const result = await doRequest(this.isEdit, payload)
      if (result?.data?.error?.type === 200) {
        this.$emit('exit', false)
      } else {
        this.$store.commit(`${MODULE_POPUP}/${SET_SUBMIT_FORM_ERROR_POPUP_SHOW}`, true)
        this.$store.commit(`${MODULE_POPUP}/${SET_SUBMIT_FORM_ERROR_POPUP_TITLE}`, 'Error to save')
        this.$store.commit(`${MODULE_POPUP}/${SET_SUBMIT_FORM_ERROR_POPUP_MESSAGE}`, result?.data?.error?.message || 'The error has occurred during execution of an operation.')
      }
    }
  }
}
